const SLIDE = 'slide'
const PRESENTATION = 'presentation'
const SLIDE_OPTIONS = 'slideOption'
const TITLE_RECOMMENDATION = 'apply-title-recommendation'
const IMAGE_KEYWORD = 'apply-image-keyword'

export const ALLOWED_OBJECT_TYPE = { SLIDE, PRESENTATION, SLIDE_OPTIONS }

export const ALLOWED_ACTION_TYPE = { TITLE_RECOMMENDATION, IMAGE_KEYWORD }
